import { createContext, useContext, useEffect, useState } from 'react';
import api from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [trial, setTrial] = useState(null);
  const [loading, setLoading] = useState(true);

  async function fetchMe() {
    try {
      const res = await api.get('/auth/me');
      setUser(res.data.user);
      setProfile(res.data.profile);
      setTrial(res.data.trial);
    } catch (e) {
      setUser(null);
      setProfile(null);
      setTrial(null);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (localStorage.getItem('sungresh_token')) fetchMe();
    else setLoading(false);
  }, []);

  function updateCredits(newCredits) {
    if (profile) setProfile({ ...profile, credits: newCredits });
  }

  async function login(email, password) {
    const res = await api.post('/auth/login', { email, password });
    localStorage.setItem('sungresh_token', res.data.access_token);
    await fetchMe();
    return res.data;
  }

  async function register(email, password, full_name) {
    await api.post('/auth/register', { email, password, full_name });
  }

  function logout() {
    localStorage.removeItem('sungresh_token');
    setUser(null);
    setProfile(null);
    setTrial(null);
    window.location.href = '/login';
  }

  return (
    <AuthContext.Provider value={{ user, profile, trial, loading, updateCredits, login, register, logout, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
